import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { systemActions } from '@/store/features/system.slice';
import { MessageType } from '@/types/message.type';
import { Link } from 'react-router-dom';
import { TimerCloseButton } from '@/components';

export default function Message({ message, link, linkText }: MessageType) {
  const dispatch = useDispatch();
  const [pause, setPause] = useState(false);

  const handleClose = () => {
    dispatch(systemActions.removeMessage());
  };

  return (
    <div className='fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black/20 z-20 p-4 md:p-0'>
      <div
        className='p-4 md:p-8 border-2 border-gray-100 rounded-xl bg-white shadow-xl max-w-full md:w-1/2
        flex flex-col'
        onMouseEnter={() => setPause(true)}
        onMouseLeave={() => setPause(false)}
      >
        <div className='relative flex space-x-2 justify-between text-sm'>
          <div className='text-base font-semibold'>
            {message}
            {link && (
              <Link
                className='mt-4 block underline text-sm font-normal'
                to={link}
                onClick={handleClose}
              >
                {linkText || 'click here'}
              </Link>
            )}
          </div>
          <TimerCloseButton
            pause={pause}
            className='absolute md:-top-12 md:-right-12 -top-8 -right-8 inline-block bg-white rounded-full p-1 hover:text-red-600 text-lg font-semibold shadow'
            onClick={handleClose}
          >
            <i className='icon-close' />
          </TimerCloseButton>
        </div>
      </div>
    </div>
  );
}
